import React from 'react';
import {FaIcon} from '../../FaIcon';


const BLOCK_TYPE_ICONS = {
    kpi_hero: 'gauge-high',
    metric_card: 'chart-simple',
    line_chart: 'chart-line',
    bar_chart: 'chart-bar',
    table: 'table',
    text: 'pen-to-square',
    separator: 'grip-lines',
};

export function TemplateBlockCard({block, t, isOwner, onClick}) {
    const icon = BLOCK_TYPE_ICONS[block.type] || 'cube';
    const typeLabel = t('templates.block_type_' + block.type) || block.type;
    const fields = block.query_params?.fields || [];

    return (
        <div
            className={`template-block-card ${isOwner ? '-clickable' : ''}`}
            style={{gridColumn: `span ${block.col_span || 12}`}}
            onClick={() => isOwner && onClick && onClick(block)}
            title={isOwner ? block.title || typeLabel : undefined}
        >
            <div className="template-block-card-header">
                <FaIcon iconName={icon}/>
                <span className="template-block-card-type">{typeLabel}</span>
                <span className="template-block-card-span">{block.col_span || 12} col</span>
            </div>
            {block.title && (
                <div className="template-block-card-title">{block.title}</div>
            )}
            {fields.length > 0 && (
                <div className="template-block-card-fields">
                    {fields.map((field, i) => (
                        <span key={i} className="template-block-card-field-chip">{field}</span>
                    ))}
                </div>
            )}
        </div>
    );
}
